'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Backdrop = exports.Footer = exports.Body = exports.Content = exports.Dialog = exports.Header = exports.Modal = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = exports.Modal = function Modal(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal', style: { display: 'block' } },
    children
  );
};

var Header = exports.Header = function Header(_ref2) {
  var title = _ref2.title,
      children = _ref2.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal-header' },
    title && _react2.default.createElement(
      'legend',
      null,
      title
    ),
    children
  );
};
Header.propTypes = {
  title: _propTypes2.default.string
};

var Dialog = exports.Dialog = function Dialog(_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal-dialog' },
    children
  );
};

var Content = exports.Content = function Content(_ref4) {
  var children = _ref4.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal-content' },
    children
  );
};

var Body = exports.Body = function Body(_ref5) {
  var children = _ref5.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal-body' },
    children
  );
};

var Footer = exports.Footer = function Footer(_ref6) {
  var children = _ref6.children;
  return _react2.default.createElement(
    'div',
    { className: 'modal-footer' },
    children
  );
};

var Backdrop = exports.Backdrop = function Backdrop() {
  return _react2.default.createElement('div', { className: 'modal-backdrop fade in' });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/Modal.js
// module id = 861
// module chunks = 0